import type { SVGProps } from 'react'

/**
 * Google の「G」ロゴ（Google Identity Services の公式ボタンと同じ 4 色版）
 * ブランドガイドラインにより、色・形は変更しない
 */
export const GoogleLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 48 48" aria-hidden="true" {...props}>
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </svg>
)

/**
 * FIDO Alliance のパスキーアイコン（人物と鍵）
 * パスキーに関する操作には、利用者が見分けられるよう一貫してこのアイコンを使う（Google / FIDO の UX ガイドライン）
 */
export const PasskeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="272 90 108 114" fill="currentColor" aria-hidden="true" {...props}>
    <path
      fillRule="evenodd"
      d="m377.05 136.85c0 9.8-6.03 18.13-14.42 21.17l5.08 8.41-7.51 9.24 7.51 9.03-12.12 16.26-8.54-9.11v-34.45c-7.59-3.45-12.91-11.35-12.91-20.55 0-12.37 9.61-22.4 21.45-22.4 11.85 0.01 21.46 10.03 21.46 22.4zm-21.46 3.44c2.86 0 5.18-2.42 5.18-5.41s-2.32-5.41-5.18-5.41-5.18 2.42-5.18 5.41 2.32 5.41 5.18 5.41z"
    />
    <path d="m340.02 161.48c-6.93-5.69-11.58-14.43-12.22-24.36h-37.14c-7.79 0-14.1 6.41-14.1 14.31v17.89c0 3.95 3.16 7.16 7.05 7.16h49.36c3.89 0 7.05-3.2 7.05-7.16z" />
    <path d="m306.56 132.83c-1.72-0.33-3.43-0.64-5.05-1.32-6.15-2.58-9.73-7.34-10.89-14.06-0.8-4.6-0.42-9.15 1.44-13.45 2.64-6.11 7.39-9.43 13.61-10.55 3.72-0.67 7.43-0.52 11.02 0.82 5.4 2.01 9.01 5.87 10.69 11.55 1.69 5.72 1.44 11.45-1.11 16.86-2.64 5.66-7.26 8.69-13.1 9.88-0.49 0.1-0.97 0.2-1.46 0.29-1.71-0.02-3.43-0.02-5.15-0.02z" />
  </svg>
)
